import React from 'react';
import { Root, Label } from '@screens/players/stat.display.styles';
import { StatIcon } from '@screens/players/stat.icon';
import { useGame } from '@domain/game.selection/game.selection.hook';

interface StatDisplayProps {
  label: string;
  icon?: string;
  oddEvenBg?: boolean;
  children?: React.ReactNode;
}

export const StatDisplay = React.forwardRef<HTMLSpanElement, StatDisplayProps>(
  ({ label, icon, oddEvenBg, children, ...rest }: StatDisplayProps, ref) => {
    const game = useGame();

    return (
      <Root oddEvenBg={oddEvenBg} ref={ref} {...rest}>
        <Label>
          {icon && game.statIcons[icon] ? <StatIcon icon={icon} alt={label} /> : label}
          {'  '}
        </Label>
        {children}
      </Root>
    );
  },
);

export const StatRow = React.forwardRef<HTMLSpanElement, StatDisplayProps>(({ label, ...rest }: StatDisplayProps, ref) => {
  return <StatDisplay oddEvenBg ref={ref} label={label} {...rest} />;
});
